import React, { useState } from 'react';

const SubidaDocumento = () => {
  const hoy = new Date().toISOString().split("T")[0]; // formato YYYY-MM-DD
  const [formData, setFormData] = useState({
    nombre: '',
    tipo: '',
    fecha_subida: '',
    fecha_caducidad: '',
    propietario: '',
    archivo: null
  });

  const handleChange = (e) => {
    if (e.target.name === 'archivo') {
      setFormData({ ...formData, archivo: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  alert("🧠 handleSubmit se está ejecutando");

  const data = new FormData();
  data.append("nombre", formData.nombre);
  data.append("tipo", formData.tipo);
  data.append("fecha_subida", formData.fecha_subida);
  data.append("fecha_caducidad", formData.fecha_caducidad);
  data.append("propietario", formData.propietario);
  data.append("archivo", formData.archivo);

  try {
    const response = await fetch("https://app.asotrans.es/api/documentos/", {
      method: "POST",
      body: data,
    });

    if (response.ok) {
      alert("✅ Documento subido con éxito");
      // Opcional: limpiar formulario
      setFormData({
        nombre: "",
        tipo: "",
        fecha_subida: "",
        fecha_caducidad: "",
        propietario: "",
        archivo: null,
      });
    } else {
      const error = await response.json();
      console.error("❌ Error al subir:", error);
      alert("❌ Falló la subida del documento");
    }
  } catch (err) {
    console.error("❌ Error de red:", err);
    alert("❌ No se pudo conectar con el servidor");
  }
};


  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto bg-white shadow-lg p-6 rounded-2xl space-y-4">
      <h2 className="text-xl font-bold text-center">Subida de Documento</h2>

      <input
        type="text"
        name="nombre"
        placeholder="Nombre del documento"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <input
        type="text"
        name="tipo"
        placeholder="Tipo de documento"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <input
        type="date"
        name="fecha_subida"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <input
        type="date"
        name="fecha_caducidad"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <input
        type="text"
        name="propietario"
        placeholder="Propietario"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <input
        type="file"
        name="archivo"
        accept="application/pdf,image/*"
        className="w-full p-2 border rounded"
        onChange={handleChange}
      />

      <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 w-full">
        Subir documento
      </button>
    </form>
  );
};

export default SubidaDocumento;
